import { Controller } from "@hotwired/stimulus"

export default class ActivityForController extends Controller {
  static targets = ["ageGroupSelect", "childsAgeSelect", "categorySelect"]

  removeOptionsFromSelect(select) {
    while (select.options.length > 1) {
      select.remove(1)
    }
  }

  async populateCategorySelects() {
    const categoryType = this.ageGroupSelectTarget.value == "Children" ? 'Child' : 'Family'
    const response     = await fetch("/activity_categories?type=" + categoryType, {headers: { accept: "application/json" }})
    const jsonString   = await response.text()
    const jsonObject   = JSON.parse(jsonString)

    this.categorySelectTargets.forEach(categoryTarget => {
      this.removeOptionsFromSelect(categoryTarget)
      jsonObject.forEach(jsonCategory => {
        let categoryOption = new Option(jsonCategory.name, jsonCategory.id)
        categoryTarget.add(categoryOption, null)
      })
      categoryTarget.disabled = false
    })
  }

  disableCategorySelects() {
    this.categorySelectTargets.forEach(categoryTarget => {
      categoryTarget.disabled = true
      this.removeOptionsFromSelect(categoryTarget)
    })
  }

  ageGroupChanged() {
    const childrenSelected = this.ageGroupSelectTarget.value == "Children"
    this.childsAgeSelectTarget.disabled = !childrenSelected
    if (!childrenSelected) {
      this.childsAgeSelectTarget.selectedIndex = -1
    }

    if (this.ageGroupSelectTarget.selectedIndex > 0) {
      this.populateCategorySelects()
    }
    else {
      this.disableCategorySelects()
    }
  }
}
